<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import { Icon } from "@lernetz/svelte-icon";

    export let title: string;
    export let results;
    export let ppl: number;
    export let onClose: () => void;
</script>

<div class="fixed inset-0 flex items-start justify-center z-50 px-16 py-24 overflow-y-auto" style="background: rgba(0,0,0,0.5)">
  <div class="bg-white rounded-3xl shadow-xl w-full md:w-728 relative px-16 md:px-24 py-20 max-h-[calc(100dvh-2rem)] md:max-h-768 overflow-y-auto">
    <div class="flex place-content-between">
      <div class="text-blue-main font-Caveat text-28 md:text-40 font-bold">
        {$t(title)}
      </div>
      <button class="border-blue-main border-2 rounded-md p-4 shrink-0" on:click={onClose}>
        <Icon name="close" class="w-32 h-32 place-self-center text-blue-main"></Icon>
      </button>
    </div>
    <div class="text-grey-1 border-b border-line-subtle text-14 flex place-content-between mt-16 pb-10">
      <div>{$t('question')}</div>
      <div>{$t('correctly answered')} (<span class="font-bold">{ppl} SuS</span>)</div>
    </div>
    {#each results as result, i}
      <div class="flex gap-12 md:gap-16 items-center py-20 border-b border-line-subtle">
        <div class="bg-yellow-accent text-white text-18 text-center p-4 rounded-full w-36 h-36 font-bold shrink-0">{i+1}</div>
        <div class="grow text-16 md:text-18 font-bold">{result.question.question}</div>
        <div class="flex items-center h-48 justify-center shrink-0">
          <div class="text-22 font-bold bg-correct-light h-full content-center w-56 rounded-l-md text-center">{result.right}</div>
          <div class="bg-line-subtle h-full content-center rounded-r-md w-44"><Icon name="check" class="w-32 h-32 place-self-center text-black"></Icon></div>
        </div>
      </div>
    {/each}
  </div>
</div>
